// for get utility of user

export const currentUser = () => {
  return JSON.parse(localStorage.getItem('user')
    ? localStorage.getItem('user')
    : sessionStorage.getItem('user'));
};

export const currentUserProjects = () => {
  const projectPermission = currentUser().permission.filter(p => {
    return (p.split('project-').length > 1);
  }).map(u => u.substring(8, u.length).toUpperCase());
  return projectPermission;
};
